<template>
   <div class="page">
     <page-header ></page-header>
     
     <div class="banners">
       <div class="main">
         <div class="containt-div">
              <div class="baner-01-a">
                <div class="caption">
                  <div class="tit">闲逸棋牌全新版本震撼来袭！</div>
                  <div class="txt">来就送，玩就送</div>
                </div>
              </div>
              <div class="baner-01-b" @click="toGames(5)">査看详情 ></div>
          </div>
       </div>
     </div>

     <div class="c-container">
       <div class="main">
         <div class="active-news">
           <div class="title">
             <img src="@/assets/images/a-title.png" >
           </div>
           <div class="news-lists">
              <ul>
                <li @click="toNews(item.type);" v-for="(item,index) in lists" :key="index"><p><i class="icon-tips1"></i>{{item.name}}</p><span>{{item.time}}</span></li>
              </ul>
            </div>
         </div>
         <div class="game-common">
           <div class="title">
             <img src="@/assets/images/a-title1.png" >
             <i class="reflush"></i>
           </div>

           <div class="game-icon">
             <div class="li" @click="toGames(item.type);" v-for="(item,index) in games" :key="index">
               <div class="l">
                 <img :src="item.icon" >
               </div>
               <div class="r">
                 <div class="tit">{{item.tit}}</div>
                 <div class="v">{{item.v}}</div>
               </div>
               <div class="arrow"></div>
             </div>
           </div>
         </div>
       </div>
     </div>

     <page-footer v-if="$route.meta.hasFooter"></page-footer>
   </div>
</template>
<script>
import Vue from 'vue'

export default {
  components: {
    pageFooter: () => import('@/components/footer'),
    pageHeader: () => import('@/components/layout/page-header')
  },
  data () {
    return {
     lists : [
       {
         name : '【六胡抢，湖南麻将，岳阳棋牌老版本迁移公告】',
         time : '2017/12/07',
         type : 1
       }
     ],
     games : [
       {
         icon : require('@/assets/images/ph-icon.png'),
         tit : '《闲逸碰碰》',
         v : 'v1.0.0版本',
         type : 2
       },
       {
         icon : require('@/assets/images/hz-icon.png'),
         tit : '《红中麻将》',
         v : 'v1.0.0版本',
         type : 3
       },
       {
         icon : require('@/assets/images/pkd-icon.png'),
         tit : '《跑得快》',
         v : 'v1.0.0版本',
         type : 6
       },
       {
         icon : require('@/assets/images/zz-icon.png'),
         tit : '《转转麻将》',
         v : 'v1.0.0版本',
         type : 4
       }
     ]
    }
  },
  created () {
  },
  mounted () {
  },
  
  methods: {
    toNews(e){
      console.log(e)
      let path = `/activityDetail?type=${e}`
      this.$router.push({
          path
      })
    },
    toGames(e){
      let path = `/gameDetail?type=${e}`
      this.$router.push({
          path
      })
    }
  }
}
</script>
<style lang="less" scoped>
.main{
  max-width: 512px;
  margin: 0 auto;
  position: relative;
}
.banners{
  height: 210px;
  background: url(../../assets/images/act-banner.jpg) no-repeat center;
  background-size: cover;

  .containt-div{
      max-width: 512px;
      position: relative;
      height: 300px;
      margin: 0 auto;
      padding-left: 10px;
      box-sizing: border-box;
      color: #fff;
  }

  .baner-01-a{
    padding-top: 110px;
    .tit{
      margin-bottom: 10px;
    }
    .txt{
      margin-bottom: 10px;
      span{
        padding-bottom: 4px;
        border-bottom: 1px solid #fff;
      }
    }
    .tags{
      span{
        margin-right: 10px;
      }
      margin-bottom: 40px;
    }
  }
  .baner-01-b{
    width: 110px;
    height: 26px;
    background: #fff;
    border-radius: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #b42ce3;
    cursor: pointer;
  }
}

.c-container{
	width: 100%;
	clear: all;
	overflow: hidden;
	background-image: url(../../assets/images/girl.png),url(../../assets/images/d-bg.png);
	background-position: left top, right bottom;
	background-repeat: no-repeat, no-repeat;
  padding-top: 15px;
  .main{
    display: flex;
    justify-content: space-between;
  }
  .active-news{
    width: 340px;
    .title{
      img{
        width: auto;
        height: 16px;
      }
    }
    .news-lists{
      border-top: 1px solid #ccc;
      margin-top: 10px;
      font-size: 8px;
      li{
        height: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #ccc;
        padding: 0 2px;
        box-sizing: border-box;
        cursor: pointer;
        p{
          display: flex;
          height: 100%;
          align-items: center;
        }
        i{
          display: block;
          width: 20px;
          height:20px;
        }
        .icon-tips1{
          background: url(../../assets/images/tip-blue.png) center center no-repeat;
          background-size: 100% auto;
        }
        .icon-tips2{
          background: url(../../assets/images/tip-grey.png) center center no-repeat;
          background-size: 100% auto;
        }
      }
    }
  }
  .game-common{
    width: 150px;
    .title{
      display: flex;
      justify-content: space-between;
      
      img{
        width: auto;
        height: 16px;
      }
      .reflush{
          width: 15px;
          height: 15px;
          background: url(../../assets/images/Refresh.png)no-repeat;
          background-size: cover;
          cursor: pointer;
      }
    }
    .game-icon{
      position: relative;
      width: 150px;
      background: #fff;
      border: 1px solid #ccc;
      margin-top: 10px;
      font-size: 8px;
      .li{
        width: 100%;
        height: 54px;
        border-bottom: 1px solid #ccc;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding-left: 10px;
        padding-right: 10px;
        cursor: pointer;
        
        .arrow{
          width: 12px;
          height: 12px;
          overflow: hidden;
          background: url(../../assets/images/a-arrow.png) no-repeat;
          background-size: auto 100%;
        }
        .l{
          width: 40px;
          height: 40px;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .r{
        }

        &:last-child{
          border: none;
        }
      }
    }
  }
}


@media (max-width:800px) {
  .c-container{
    .main{
      display: block;
    }
    .active-news , .game-common{
      width: 100%;
      padding: 0 10px;
      box-sizing: border-box;
    }
    .game-common{
      margin-top: 20px;
      margin-bottom: 20px;
      .game-icon{
        width: 100%;
        .li{
          justify-content: flex-start;
          .r{
            padding-left: 10px;
            width: 270px;
          }
        }
      }
    }
    
  }
}


</style>
